<template>
  <div class="main">
    <div class="nav">
      <van-nav-bar
        title="缴费记录"
        left-arrow
        :fixed=flexfalg
        @click-left="onClickLeft"
      />
      <div class="top"></div>
      <!-- <Nav :title="'缴费记录'" :fixed="true"></Nav>
      <div class="top"> -->
    </div>
  <van-notice-bar
  left-icon="info-o"
  color="#1989fa"
  background="#ecf9ff"
  :scrollable="true"
  :text=this.tips
/>
    <div class="cholseDate">
      <div class="dateitem" :value="begindate"  @click="showCalendar['begindate'] = true">{{begindate}}</div>
      <div class="dateitem_-">~</div>
      <div class="dateitem" :value="enddate" @click="showCalendar['enddate'] = true">{{enddate}}</div>
      <van-calendar color="#5b8df6" :min-date="minDate" 
      :max-date="maxDate" v-model="showCalendar['begindate']" @confirm="(value) =>onConfirm(value,'begindate')" />
      <van-calendar color="#5b8df6" :min-date="minDate" 
      :max-date="maxDate" v-model="showCalendar['enddate']" @confirm="(value) => onConfirm(value,'enddate')" />
    </div>
    <div v-if="emptyflag">
      <van-empty image="https://account.kmmds.top/datainfo_pic/error.png" description="暂无缴费信息" />
    </div>
    <div class="paycard"  v-for="(item,index) in hisList" :key="index" v-else @click="gopayhisDetail(item.InvoiceNO,item.RegisterNo,item.isPrint)">
      <div class="head">
        <div>发票号：{{item.InvoiceNO}}</div>
        <div>{{name}}</div>
      </div>
      <div claass="content">
        <!-- <div class="Crow">
          <div></div>
          <div class="green">已缴费</div>
        </div> -->
        <div class="Crow">
          <div>支付方式</div>
          <div>{{item.PayMode}}</div>
        </div>
         <div class="Crow">
          <div>打印状态</div>
          <div>{{item.isPrint |isPrinttotest}}</div>
        </div>
        <div class="Crow" v-if="item.DepartmentName">
          <div>科室</div>
          <div>{{item.DepartmentName}}</div>
        </div>
         <div class="Crow">
          <div>支付类型</div>
          <div>{{item.PactName}}</div>
        </div>
         <div class="Crow">
          <div>挂号单据号</div>
          <div>{{item.RegisterNo}}</div>
        </div>
        <div class="Crow">
          <div>费用</div>
          <div>￥:{{item.TotalCost |FinalPrice}}</div>
        </div>
       <div class="Crow">
          <div>缴费时间</div>
          <div>{{item.PayDate}}</div>
        </div>
      </div>
      <div class="Crow" v-if="item.isPay =='0'">
          <div></div>
          <div>
            <van-button  size="small" @click.stop="repay(item)">退费</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import setOptions from "@/mixins/setOption";
export default {
     mixins: [setOptions],
  data() {
    return {
      emptyflag: false,
      showCalendar: {
        begindate: false,
        enddate: false,
      },
      hisList: [],
      show: false,
      begindate: new Date(),
      enddate: new Date(),
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      flexfalg: true,
      clientId: "",
      name: "",
      payHisInfo: [],
      version:"",
      tips:""
    };
  },
  components: {
    Nav,
  },
  mounted() {
    if (this.$route.query) {
      this.clientId = this.$route.query.clientId;
      this.name = this.$route.query.name;
      this.enddate = this.getyDay(this.enddate);
      this.begindate = this.getLmDay(this.begindate);
    }
    if (!this.clientId || this.clientId == "") {
      // this.Dialog();
      this.$router.push("/patient_card_selectuser");
      return;
    }
    this.gethistoList();
    this.getPayWay();
  },
  filters: {
    FinalPrice(price) {
      return Number(price).toFixed(2);
      // console.log(price);
    },
    isPrinttotest(isPrint) {
      if (isPrint == 1) {
        return "已打印";
      } else if (isPrint == 0) {
        return "未打印";
      }
    },
    reBtn(isPay) {
      if (isPay == 0) {
        return "退费";
      } else if (isPay == 1) {
        return "不可退费";
      }
    },
  },
  methods: {
      async getTips() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/queryTips";
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
         this.tips=data.data.pay
         this.$hideLoad()
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    async getPayWay() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getPayType";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            this.version = data.data.version;
             console.log(data.data)
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
  async  repay(item) {
      console.log(item);
      if (item.isRefund == "1") {
        this.$toast.fail("该挂号已就诊，无法退费");
        return;
      }
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/register/hisrefundfee";
        let R_data = {
          clientId: this.clientId,
          invoiceNo: item.InvoiceNO,
          version: this.version,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          R_data,
          (data) => {
            // console.log(data);
            this.$hideLoad()
           console.log(data)
           
           if(data.statusText=="退费成功" &&data.status==200){
             this.$toast.success('退费成功')
           }else if(data.statusText=="该订单已退款"){
                 this.$toast.fail('该订单已退款,请勿重复操作')
           }else{
             this.$toast.fail('退费失败，联系管理员或到窗口退费')
           }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    gopayhisDetail(InvoiceNO, RegisterNo, isPrint) {
      this.$router.push({
        path: "/pay_history_D_detail",
        query: {
          InvoiceNO: InvoiceNO,
          RegisterNo: RegisterNo,
          isPrint: isPrint,
        },
      });
    },
    //获取列表
    async gethistoList() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/outpatientfeePayedListD";
        let R_data = {
          patientId: this.clientId,
          start_date: this.begindate,
          end_date: this.enddate,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          R_data,
          (data) => {
            // console.log(data);
            if (data.data.data.List.Item.length == 0) {
              this.emptyflag = true;
              this.$hideLoad();
              return;
            }
            this.hisList = data.data.data.List.Item;
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    getyDay(date) {
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * 7);
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    //获取上个月
    getLmDay(date) {
      date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * 30);
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    //选择日期
    onConfirm(value, type) {
      //  console.log(new Date(value))
      //  console.log( type)
      this[type] = this.formatDate(new Date(value));
      console.log(this.showCalendar[type]);
      this.showCalendar[type] = false;
      this.gethistoList();
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    //获取列表
    // this.isLoad = true
    go_detail() {
      this.$router.push({
        path: "/pay_history_D_detail",
        query: {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  .top {
    height: 50px;
  }
  .cholseDate {
    widows: 90%;
    display: flex;
    margin: 0px auto;
    margin-top: 10px;
    .dateitem_- {
      margin-left: 20px;
      color: #95a5a6;
    }
    .dateitem {
      margin-left: 20px;
      color: #95a5a6;
      border-bottom: 1px solid #95a5a6;
    }
  }
  .paycard {
    padding: 5px;
    width: 90%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #5b8df6;
    border-radius: 15px;
    margin: 0px auto;
    margin-top: 8px;
    margin-bottom: 8px;
    box-shadow: 0 8px 12px #6666;
  }
  .head {
    margin-left: 10px;
    margin-right: 10px;
    color: #5b8df6;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #5b8df6;
    font-size: 16px;
  }
  .content {
    width: 90%;
    display: flex;
    flex-direction: column;
    border: 1px solid #95a5a6;
    border-radius: 15px;
    margin: 5px auto;
  }
  .Crow {
    color: #747d8c;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 25px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .gold {
      color: #e74c3c;
    }
    .green {
      color: #2ed573;
    }
  }
  .line {
    border-bottom: 1px solid #95a5a6;
  }
}
</style>